import { HttpRequest, httpErrorHandler } from "../../handler"

export default {
  namespaced: true,
  state: {
    topBanners: {}
  }, 
  mutations: {
    setTopBanners(state, payload) {
      state.topBanners = payload
    }
  },
  actions: {
    async getTopBanners(context, payload) {
      const url = 'bannerTop'
      const {success, result, message} = await HttpRequest.authorizedRequest(url, 'GET', {}, {}, {})
      if (success) {
        context.commit('setTopBanners', {
          data: result.data.sort((a, b) => a.order - b.order)
        })
        return true
      } else {
        httpErrorHandler(message)
        return false
      }
    },
    async createTopBanner(context, payload) {
      const url = 'bannerTop'
      const { bgColor, image, product, order } = payload
      const { success, result, message } = await HttpRequest.authorizedRequest(url, "POST", {bgColor, image, product, order})
      if(success) {
        context.dispatch('getTopBanners')
        return true
      } else {
        httpErrorHandler(message)
        return false
      }
    },
    async changeOrder(context, payload) {
      const { bannerId, order } = payload
      const url = 'bannerTop/' + bannerId + '/order'
      const result = await HttpRequest.authorizedRequest(url, "PATCH", {order})
      console.log(result)
      if(result.success) {
        alert('Save order successfully');
        return true
      } else {
        httpErrorHandler(message)
        return false
      }
    },
    async deleteTopBanner(context, payload) {
      const {_id} = payload
      const url = `bannerTop/${_id}`
      const {success, result, message } = await HttpRequest.authorizedRequest(url, "DELETE", {}, {})
      if(success) {
        context.dispatch('getTopBanners')
        return true
      } else {
        httpErrorHandler(message)
        return false
      }
    }
  }
}